/**
 * Created by Mikhail Menshenin on 03.07.2024
 */

class CoinKingdom extends GameBase {
    constructor(level, options) {
        super(level, options);

        this.slotMachine = aisensia.slotMachine;
    }

    takeLife() {
    }

    useLives() {
        return false;
    }

    leave(f) {
        cleverapps.meta.gotoMainLocation(f);
    }

    static OpenSlotMachine(f) {
        new Level(0, 0).play(f);
    }

    static OpenVillageAction(prefab, village, f) {
        cleverapps.scenes.replaceScene(Prefab.instantiate(prefab, { args: { village } }), f);
    }
}

Game = CoinKingdom;
